"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PollStatus", {
  enumerable: true,
  get: function get() {
    return _consts.PollStatus;
  }
});
Object.defineProperty(exports, "PollTeacherActions", {
  enumerable: true,
  get: function get() {
    return _consts.PollTeacherActions;
  }
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollsList = _interopRequireDefault(require("./PollsList"));

var _PollContent = _interopRequireDefault(require("./PollContent"));

var _styles = require("./styles");

var _consts = require("./consts");

function PollTeacher(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      polls = props.polls,
      selectedPollId = props.selectedPollId,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "polls", "selectedPollId"]);
  var selectedPoll = polls.find(function (poll) {
    return poll.pollId === selectedPollId;
  });
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.pollRootStyles, className)
  }, _react.default.createElement(_PollsList.default, (0, _extends2.default)({
    polls: polls,
    selectedPollId: selectedPollId
  }, rest)), _react.default.createElement(_PollContent.default, (0, _extends2.default)({
    poll: selectedPoll
  }, rest, {
    polls: polls
  })));
}

var _default = PollTeacher;
exports.default = _default;